import { BadgeAccountIcon } from './BadgeAccountIcon';

/**
 * author: Michael Richins
 * id AE2E869B-B420-4505-9EE0-EE3751478D64
 * name badge-account
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/badge-account.svg
 * tags
 * - Account / User 
 */
export const UserBadgeIcon = BadgeAccountIcon;
export default UserBadgeIcon